import { Routes, Route, useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { useEffect } from "react";
import Home from "./pages/Home";
import Mask_Group from '../src/assets/Mask group.svg';
import Grey_indicator from '../src/assets/Grey Indicator.svg';
import SignedOut from "./pages/SignedOut";
import AdminPanel from "./pages/AdminPanel";
import ShouldCost from "./pages/ShouldCost";
import Dashboard from "./pages/Dashboard";
import Summary from "./pages/Summary";
import Layout from "./pages/Layout";
import LandingPage from "./pages/LandingPage";
import CategoryShouldCost from "./pages/CategoryShouldCost";
import Overview from "./pages/Overview";
import Chatbotjs from "./pages/Chatbotjs";
import Analysis from "./pages/Analysis";
import Negotiation from "./pages/Negotiation";
import ShouldChatbot from "./pages/ShouldChatbot";

function LogPage() {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated) {
      auth.signinRedirect();
    }
  }, [auth.isLoading, auth.isAuthenticated]);

  const signOutRedirect = () => {
    const clientId = "17dnm9s9f6bd760h4c69lfe0bh";
    // const logoutUri = "https://d39hs47lec3pp9.cloudfront.net/signed-out";
    // const logoutUri = "http://localhost:3000/signed-out";
    const logoutUri = "https://auracostai.accentureanalytics.com/signed-out";
    const cognitoDomain = "https://us-east-1odeymrqa8.auth.us-east-1.amazoncognito.com";
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };
  console.log("isLoading:", auth.isLoading);
  console.log("isAuthenticated:", auth.isAuthenticated);
  console.log("user:", auth.user);
  console.log("error:", auth.error);

  if (auth.isLoading) {
    return (
      <div
        className="fixed inset-0 flex items-center justify-center z-50"
        style={{
          backgroundImage: "linear-gradient(to bottom right, #E6DCFF, #fffce9ff)"
        }}
      >
        <div className="chatbot-loaderInside text-center">
          <span className="chatbot-loaderImg">
            <span className="relative inline-block w-8 h-8">
              <img
                src={Mask_Group}
                alt="Mask_Group"
                className="Mask_Group absolute top-0 left-0 w-full h-full animate-spin"
              />
              <img
                src={Grey_indicator}
                alt="Grey_indicator"
                className="Grey_indicator absolute top-1/4 left-1/4 w-1/2 h-1/2 animate-spin"
              />
            </span>
          </span>
        </div>
      </div>
    );
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }
  if (auth.isAuthenticated) {
    const username = auth.user?.profile["cognito:username"] || auth.user?.profile?.preferred_username || auth.user?.profile?.email || "User";
    // const token = auth.user?.access_token;
    const token = auth.user?.id_token;
    return (
      <Routes>
        <Route path="/" element={<Dashboard username={username} onSignOut={signOutRedirect} token={token} />} />
        <Route path="/summary" element={<Summary username={username} onSignOut={signOutRedirect} />} />
        {/* <Route path="/" element={<Home username={username} onSignOut={signOutRedirect} token={token} />} /> */}
        <Route path="/signed-out" element={<SignedOut />} />
        <Route path="/adminPanel" element={<AdminPanel username={username} onSignOut={signOutRedirect} token={token} />} />
        <Route path="/should-cost" element={<ShouldCost username={username} onSignOut={signOutRedirect} />} />
        <Route path="/Category" element={<CategoryShouldCost username={username} onSignOut={signOutRedirect} />} />
        <Route path="/Overview" element={<Overview username={username} onSignOut={signOutRedirect} />} />
        <Route path="/LandingPage" element={<LandingPage username={username} onSignOut={signOutRedirect} />} />
        <Route path="/Analysis" element={<Analysis username={username} onSignOut={signOutRedirect} />} />
        <Route path="/Chatbot" element={<Chatbotjs username={username} onSignOut={signOutRedirect} />} />
        <Route path="/ShouldChatbot" element={<ShouldChatbot username={username} onSignOut={signOutRedirect} token={token} />} />
        
        <Route path="/Negotiation" element={<Negotiation username={username} onSignOut={signOutRedirect} />} />
      </Routes>
    );
  }

  return null;
}

export default LogPage;
